// extracted by mini-css-extract-plugin
export default {"modalContent":"FullAccessModal_modalContent__iML7J"};